import React, { Fragment } from "react";
import "./not_found.css";

const NotFound = () => {
  return (
    <Fragment>
      <div className="container-fluid page_body_404">
        <div className="row title_404_body ">اوه!</div>
        <div className="row image_404_body">
          <img
            className="image_404"
            src="https://s21.picofile.com/file/8441606000/page404.png"
          />
        </div>
        <di className="text_404_body">
          <p>بنظر میرسه این صفحه وجود نداره </p>
        </di>
      </div>
    </Fragment>
  );
};

export default NotFound;
